import md5 from 'js-md5';
import Http from './http';
import { envPrefix } from '@/libs/env';

export default {

  buildWxaHeader() {
    const header = {
      wxaver: '1.1.1',
      noncestr: this.ranString(16),
      platform: '13',
    };

    header.sign = md5(`wxaver=${header.wxaver}&noncestr=${header.noncestr}&platform=${header.platform}&secretkey=F59637C327AB205A01BB44123B4A6A4E`);

    return header;
  },


  // peer_to_wxa 是从官网通过扫码进行小程序的标识
  getInsuranceDetailWxaCode(id) {
    return new Promise(((resolve, reject) => {
      const page = 'subpackage/pages/insurance-order/product-detail/product-detail';
      // s: is_share
      const scene = `id=${id}&s=1`;
      const postData = {
        page,
        scene,
        size: 300,
      };

      Http.post('/sys/qrcode_get', postData).then((data) => {
        resolve(`data:image/jpeg;base64,${data.qrcode}`);
      }).catch((err) => {
        reject(err);
      });
    }));
  },

  // 获取小程序二维码和短链URL
  async getWxaQrcodeAndUrl({ page, scene }) {
    const long_url = `https://${envPrefix}h5.666visa.cn/#/open-wxa?path=${encodeURIComponent(page)}&query=${scene ? encodeURIComponent(`scene=${encodeURIComponent(scene)}`) : ''}`;
    const [qrcodeRes] = await Promise.all([
      Http.post('/sys/qrcode_get', {
        page,
        scene,
        size: 300,
      }),
      // 现在的短链服务，在微信内被封了 ，所以先用长链
      // Http.post('/sys/convert_short', {
      //   long_url,
      // }),
    ]);
    return {
      qrcode_url: `data:image/jpeg;base64,${qrcodeRes.qrcode}`,
      // short_url: shortUrlRes.short_url,
      long_url,
    };
  },

  // peer_to_wxa 是从官网通过扫码进行小程序的标识
  getVisaDetailWxaCode(visa_product_id, peer_account_id, peer_to_wxa, province_code) {
    return new Promise(((resolve, reject) => {
      const page = 'pages/visa/visa-detail/visa-detail';

      // visa_product_id -> v  peer_account_id -> a  peer_to_wxa -> w
      let scene = `v=${visa_product_id}&a=${peer_account_id}`;
      if (peer_to_wxa) {
        scene = `${scene}&w=${peer_to_wxa}`;
      }
      if (province_code) {
        scene = `${scene}&p=${province_code}`;
      }
      const postData = {
        page,
        scene,
        size: 300,
      };

      Http.post('/sys/qrcode_get', postData).then((data) => {
        resolve(`data:image/jpeg;base64,${data.qrcode}`);
      }).catch((err) => {
        reject(err);
      });
    }));
  },

  // 获取国家页小程序二维码
  getCountryWxaCode(visa_country_id, peer_account_id) {
    return new Promise(((resolve, reject) => {
      const page = 'pages/visa/visa/visa';

      // visa_country_id -> v  peer_account_id -> a  peer_to_wxa -> w
      const scene = `v=${visa_country_id}&a=${peer_account_id}`;

      const postData = {
        page,
        scene,
        size: 300,
      };

      Http.post('/sys/qrcode_get', postData).then((data) => {
        resolve(`data:image/jpeg;base64,${data.qrcode}`);
      }).catch((err) => {
        reject(err);
      });
    }));
  },

  // 订单页二维码
  getOrderDetailWxaCode(user_order_id, peer_account_id) {
    return new Promise(((resolve, reject) => {
      const page = 'pages/order/order-detail/order-detail';

      // user_order_id -> u  peer_account_id -> a
      const scene = `u=${user_order_id}&a=${peer_account_id}`;

      const postData = {
        page,
        scene,
        size: 300,
      };

      // 正式环境生成的二维码才有用
      Http.post('/sys/qrcode_get', postData).then((data) => {
        resolve(`data:image/jpeg;base64,${data.qrcode}`);
      }).catch((err) => {
        reject(err);
      });
    }));
  },

  // 分享赴馆通知书
  getQRCode(user_order_id, order_applicant_id) {
    return new Promise((resolve, reject) => {
      const page = 'pages/order/embassy-notice/embassy-notice';

      // user_order_id => u order_applicant_id -> i
      const scene = `u=${user_order_id}&i=${order_applicant_id}`;

      const postData = {
        page,
        scene,
        size: 300,
      };

      Http.post('/sys/qrcode_get', postData)
        .then((data) => {
          resolve(`data:image/jpeg;base64,${data.qrcode}`);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 获取申请人上传页面qrcode
  getApplicantUploadQRCode(order, peerAccountId) {
    return new Promise((resolve, reject) => {
      const page = 'pages/apply/ordering/upload/upload';
      // const page = 'pages/apply/apply-data';
      const scene = `t=q&u=${order.user_order_id}&p=${peerAccountId}`;
      const postData = {
        page,
        scene,
        size: 300,
      };

      Http.post('/sys/qrcode_get', postData)
        .then((data) => {
          resolve(`data:image/jpeg;base64,${data.qrcode}`);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // 绑定页面
  getBindPageQRCode(peer_account_id, rebind) {
    return new Promise(((resolve, reject) => {
      const page = 'pages/bind/bind/bind';

      // user_order_id -> u  peer_account_id -> a
      const scene = `p=${peer_account_id}${rebind ? '&r=1' : ''}`;

      const postData = {
        page,
        scene,
        size: 300,
      };

      // 正式环境生成的二维码才有用
      Http.post('/sys/qrcode_get', postData).then((data) => {
        resolve(`data:image/jpeg;base64,${data.qrcode}`);
      }).catch((err) => {
        reject(err);
      });
    }));
  },
};



// WEBPACK FOOTER //
// ./src/libs/wx-utils.js